export async function postJson(url, payload) {
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(payload)
  });

  return response.json();
}

